import { useAuth0 } from '@auth0/auth0-react';
import SinglePageNavbar from '../components/SinglePageNavbar';
import Footer from '../components/Footer';

function SinglePageLayout({ children }) {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '100vh' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="single-page-container">
      <SinglePageNavbar />
      <main className="single-page-content">{children}</main>
      <Footer />
    </div>
  );
}

export default SinglePageLayout;
